import styled from 'styled-components';
import {tokens} from '@tickchak/react-share/app';
import {dFlex, flexWrap, flexRowReverse, alignStart, alignCenter, justifyEnd} from '../../../../../../../globalVariables/GlobalFlex';
import {wideCardsMedia} from '../../timetableSales.css';

export {dot} from '../../timetableSales.css';

export const legend = styled.div`
  ${dFlex}
  ${flexWrap}
  ${alignStart}
  ${justifyEnd}
  align-self: stretch;
  gap: var(--space-lg);
  ${wideCardsMedia}{ gap: var(--space-sm); }
`;
export const legendItem = styled.div`
  ${dFlex}
  ${flexRowReverse}
  ${alignCenter}
  gap: var(--space-sm);
  font-size: ${tokens.typography.fontSize.bodySmall};
  line-height: 20.5px;
  white-space: nowrap;
`;
export const vLine = styled.div`
  width: 1px;
  height: 19px;
  align-self: center;
  background: var(--TA-color-border-subtle);
  ${wideCardsMedia}{ display: none; }
`;
